import { MenuItem } from 'react-pro-sidebar';
import { Link } from '@tanstack/react-router';
import { SidebarMenuItemProps } from './SidebarMenuitem.types';
import { SidebarCount } from '../SidebarCount';
import { Typography } from '../../Typography';
import { RenderWhen } from '../../RenderWhen';

export const SidebarMenuItem = ({
  isActive,
  icon,
  count,
  label,
  to,
  onClick,
  isFirstLevel,
  classNameCount,
}: SidebarMenuItemProps) => (
  <MenuItem
    data-testid={`SidebarMenuItem-container-${label}`}
    onClick={onClick}
    active={isActive}
    icon={icon}
    component={<Link to={to ?? '#'} />}
    suffix={count != null && <SidebarCount classNameCount={classNameCount} count={count} />}
  >
    <RenderWhen
      condition={Boolean(isFirstLevel)}
      onFalse={<Typography className="!pointer-events-none">{label}</Typography>}
    >
      <Typography variant="h5" className="!pointer-events-none text-secondary-100 underline">
        {label}
      </Typography>
    </RenderWhen>
  </MenuItem>
);
